<template> <!-- 收件人信息 -->

  <el-form
    ref="ruleForm"
    class="demo-ruleForm" label-position="top"
  >
    <el-row :gutter="20">
      <el-col :span="8">
        <!-- 姓名 -->
        <el-form-item :label="$t('newOrder.RecipientName')">
          <encryption-field
            field-name="receiveName"
            :encrypted-value="ruleForm.receiveName"
            :label="$t('newOrder.RecipientName')"
          />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <!-- 公司 -->
        <el-form-item :label="$t('newOrder.RecipientCompany')">
          <encryption-field
            field-name="receiveCompany"
            :encrypted-value="ruleForm.receiveCompany"
            :label="$t('newOrder.RecipientCompany')"
          />

        </el-form-item>
      </el-col>
      <el-col :span="8">
        <!-- 手机 -->
        <el-form-item :label="$t('newOrder.Recipientphone')">
          <encryption-field
            field-name="receiveMobile"
            :encrypted-value="ruleForm.receiveMobile"
            :label="$t('newOrder.Recipientphone')"
          />

        </el-form-item>
      </el-col>
      <el-col :span="8">
        <!-- 街道 -->
        <el-form-item :label="$t('driver.modalStreet')">
          <span>{{ ruleForm.receiveStreet }}</span>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <!-- 门牌号 -->
        <el-form-item :label="$t('newOrder.doorNumber')">
          <span>{{ ruleForm.receiveHouseNumber }}</span>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <!-- 区 -->
        <el-form-item :label="$t('newOrder.RecipientDistrict')">
          <span>{{ ruleForm.receiveArea }}</span>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <!-- 城市 -->
        <el-form-item :label="$t('newOrder.RecipientCity')">
          <span>{{ ruleForm.receiveCity }}</span>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <!-- 州 -->
        <el-form-item :label="$t('newOrder.RecipientState')">
          <span>{{ ruleForm.receiveState }}</span>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <!-- 邮编 -->
        <el-form-item :label="$t('newOrder.RecipientZipCode')">
          <span>{{ ruleForm.receiveZipcode }}</span>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <!-- 地址补充 -->
        <el-form-item :label="$t('GlobalSetObj.recipientComplement')">
          <encryption-field
            field-name="receiveComplement"
            :encrypted-value="ruleForm.receiveComplement"
            :label="$t('GlobalSetObj.recipientComplement')"
          />

        </el-form-item>
      </el-col>
      <el-col :span="8">
        <!-- 税号 -->
        <el-form-item :label="$t('newOrder.RecipientCPF')">
          <encryption-field
            field-name="receiveTax"
            :encrypted-value="ruleForm.receiveTax"
            :label="$t('newOrder.RecipientCPF')"
          />

        </el-form-item>
      </el-col>
      <el-col :span="8">
        <!-- 州注册号 -->
        <el-form-item :label="$t('navbar.receiveIe')">
          <span>{{ ruleForm.receiveIeNumber }}</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="8">
        <!-- 地址 -->
        <el-form-item :label="$t('newOrder.ReceivingAddress')">
          <encryption-field
            field-name="receiveAddress"
            :encrypted-value="ruleForm.receiveAddress"
            :label="$t('newOrder.ReceivingAddress')"
          />

        </el-form-item>
      </el-col>
      <el-col :span="8">
        <!-- 电话 -->
        <el-form-item :label="$t('newOrder.Recipientphonenumber')">
          <encryption-field
            field-name="receivePhone"
            :encrypted-value="ruleForm.receivePhone"
            :label="$t('newOrder.Recipientphonenumber')"
          />

        </el-form-item>
      </el-col>
      <el-col :span="8">
        <!-- 邮箱 -->
        <el-form-item :label="$t('newOrder.RecipientEmail')">
          <encryption-field
            field-name="receiveMail"
            :encrypted-value="ruleForm.receiveMail"
            :label="$t('newOrder.RecipientEmail')"
          />

        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
export default {
  name: '',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    'encryption-field': () => import('@/components/EncryptionField/index.vue')
  },
  props: {
    ruleForm: {
      type: Object,
      required: true
    }
  }

};
</script>

<style scoped>
span {
  color: #666;
}
</style>
